import ArrowIcon from "@mui/icons-material/KeyboardArrowRight";
import NotificationIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { Grid } from "@mui/material";
import InitialsAvatar from "../../../common/components/functional/initialsAvatar/InitialsAvatar";
import SkeletonWrapper from "../../../common/components/functional/skeletonWrapper/SkeletonWrapper";
import {
  formatDateRange,
  formatDateTime,
} from "../../../common/helpers/formatDateTime";
import { OrderFields } from "../orderTypes";
import {
  PreviewNotificationContainer,
  PreviewNotificationText,
  PreviewNotificationUnread,
} from "./styles";
import { ShiftDetailsType } from "./types";

type Props = {
  values: OrderFields;
  dates: Array<Date> | null;
  shiftDetails: ShiftDetailsType[];
};

const PreviewNotification = ({ values, shiftDetails, dates }: Props) => {
  const header =
    values.workLocation.name &&
    values.orderTemplate.name &&
    `${values.workLocation.name} - ${values.orderTemplate.name}`;

  const address = `${values.workLocation.address.street}, ${values.workLocation.address.zip} ${values.workLocation.address.city}`;

  const dateTime = dates
    ? // bundle
      formatDateRange(dates, "d.M")
    : // single row
      formatDateTime(
        shiftDetails[0].date,
        shiftDetails[0].time,
        "dateTimeRangeLabels",
        "d.M",
      );

  return (
    <PreviewNotificationContainer>
      <Grid item container alignItems="center">
        <InitialsAvatar name={values.workLocation.name} />
      </Grid>
      <Grid item container sx={{ margin: "0 0.5rem" }}>
        <Grid item sx={{ lineHeight: "18px" }}>
          <SkeletonWrapper value={header} height="16px" width="205px">
            <PreviewNotificationText variant="header" sx={{ fontWeight: 600 }}>
              {header}
            </PreviewNotificationText>
          </SkeletonWrapper>
        </Grid>
        <Grid item sx={{ lineHeight: "18px" }}>
          <SkeletonWrapper value={address} height="12px" width="180px">
            <PreviewNotificationText>{address}</PreviewNotificationText>
          </SkeletonWrapper>
        </Grid>
        <Grid item sx={{ lineHeight: "18px" }}>
          <SkeletonWrapper value={dateTime} height="12px" width="130px">
            <PreviewNotificationText variant="secondary">
              {dateTime}
            </PreviewNotificationText>
          </SkeletonWrapper>
        </Grid>
      </Grid>
      <Grid
        item
        container
        justifyContent="flex-end"
        alignItems="center"
        direction="row"
        flexWrap="nowrap"
      >
        <Grid item>
          <NotificationIcon />
          <PreviewNotificationUnread />
        </Grid>
        <Grid item>
          <ArrowIcon />
        </Grid>
      </Grid>
    </PreviewNotificationContainer>
  );
};

export default PreviewNotification;
